import React, { useEffect } from 'react';
import { msalInstance } from '../../auth';

const LogoutPageRedirect = () => {
    useEffect(() => {
        // declare the data fetching function
        const logOutFn = async () => {
            await msalInstance.logoutRedirect();
        };

        // call the function
        logOutFn()
            // make sure to catch any error
            .catch(console.error);
    }, []);

    return <>Logging out...</>;
};

export default LogoutPageRedirect;
